// 英文语言包
export default {
  cancel: 'cancel',
  confirm: 'confirm',
  noData: 'No data',
  endTips: 'There is no more,let\'s see something else',
  copySuccess: 'copy success',
  failed: 'copy failed',
  // index 首页
  index: {
    searchTips: 'Search for the product or store you want to buy',
    newProduct: 'New Products',
    specialDiscounts: 'Special discounts',
    groupDiscount: 'Group discount',
    spikeSpecial: 'Seckill discount',
    couponCentre: 'Coupon Centre',
    memberCentre: 'Member Centre',
    distributionCentre: 'Distribution Centre',
    pointsMall: 'Integral Mall',
    spikeZone: 'Seckill',
    day: 'days',
    seckillTips: 'The  flash sale is in progress',
    more: 'More',
    dailyRecommendation: 'Recommend',
    recommendationTips: 'Fresh good things',
    prodNotFoundTips: 'No related products were found,let\'s see something else',
    noMoreTips: 'There is no more,let\'s see something else'
  },
  // user-setting 用户设置页面
  userSettings: {

  },
  // payment 支付页面
  payment: {
    theRemainingTime: 'The remaining time',
    determinePayment: 'Determine the payment',
    PayWithAli: 'Ali-Pay',
    payWithWeChat: 'WeChat Pay',
    balancePay: 'Balance Pay',
    cardPay: 'Card Pay',
    tips: 'Tips',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmBalancePay: 'Whether to confirm payment with balance?After clicking the confirm button, the amount of this order will be paid from the balance',
    cancelBalancePay: 'Payment with balance cancelled',
    shortBalance: 'Insufficient balance, Please recharge first! Current account balance:'
  },
  // my 我的页面
  my: {
    changeLang: '中文版'
  },
  distribution: {
    // applyDist.vue
    applyDistributor: 'Apply to become a distributor',

    // applyDistCon.vue
    mobilePhone: 'Mobile phone number',
    actualName: 'real name',
    identification: 'ID number',
    identificationTips: 'Please enter the correct ID number',
    uploadIDFront: 'Please upload ID portrait face',
    uploadIDBack: 'Please upload the national emblem side of the ID card',
    uploadIDHand: 'Please upload handheld ID photo',
    enterRealName: 'Please enter your real name',
    applicationSubmitted: 'Application has been submitted, please wait for review',
    enterMobileNumber: 'Please enter your cell phone number',
    enterMobileNumberTips: 'Mobile phone number input error',
    submitApplication: 'Submit application',
    applicationReview: 'Your submitted application is being reviewed',
    applicationFailed: 'Your application has not been approved, please consult customer service for details and re-apply',
    distributorBanned: 'Your distributorship has been banned, please contact customer service for more details',
    distributionPromotionHasBeenClosed: 'Distribution promotion has been closed',
    distributorCleared: 'Your distributorship has been blocked, please contact the administrator',
    cancel: 'cancel',
    confirm: 'confirm',
    // dis-center.vue
    noAnnouncement: 'No announcement at this time',
    vip: 'Member',
    myBalance: 'Withdrawable balance ($)',
    totalIncome: 'Total earnings ($)',
    withdrawalsNow: 'withdraw now',
    promoteGoods: 'Promote goods',
    distributionWinWin: 'DistributionWinWin',
    inviteFriends: 'Invite friends',
    promoteRewards: 'Promote Rewards',
    myUser: 'My users',
    myPromotion: 'My promotions',
    distributorList: 'List of distributors',
    incomeBreakdown: 'Earnings details',
    withdrawalsRecord: 'Withdrawals record',

    // withdrawal.vue
    withdrawalAmount: 'Withdrawal amount',
    availableCashAmount: 'Available cash amount $',
    withdrawAll: 'All withdrawals',
    confirmWithdrawal: 'Confirm withdrawal',
    enterCorrectAmount: 'Please enter the correct amount!',
    insufficientBalance: 'Insufficient balance',
    lessThanWithdrawalAmount: 'The withdrawal amount is less than the minimum withdrawal amount',
    withdrawalApplicationSubmitted: 'The withdrawal application has been submitted',

    // draw-rule.vue
    WithdrawalRules: 'Withdrawal Rules',
    WithdrawalRules1: '1. The single withdrawal amount shall not be less than',
    yuan: 'yuan',
    WithdrawalRules2: 'and may not be higher than',
    WithdrawalRules3: '2. There is no limit to the number of withdrawals per user per day',
    WithdrawalRules31: '2. Each user can withdraw unlimited amounts per day',
    WithdrawalRules32: 'Days with',
    WithdrawalRules34: 'Monthly',
    WithdrawalRules33: 'withdrawals per user',
    WithdrawalRules4: 'The final right of interpretation belongs to the platform.',

    // take-notes.vue
    noRecords: 'No records at this time',
    totalWithdrawa: 'Total withdrawals',
    wechatPayment: 'WeChatPayment',
    offlinePayment: 'OfflinePayment',
    theFallback: 'Fallback',
    rejection: 'Rejecting withdrawal',
    withdrawing: 'withdrawing',
    hasArrived: 'Arrived',
    loading: 'Loading...',
    noMore: 'No more~',
    noPromotionProduct: 'No promotion product found~',
    noRecordsFound: 'No related records found',
    noWithdrawalRecord: 'No withdrawal records yet~',
    unpaid: 'Unpaid',
    applicationApproved: 'Application approved',
    successfulWithdrawal: 'Successful withdrawal',
    withdrawalFailed: 'Withdrawal failed',

    // income-details.vue
    cumulativeIncome: 'Cumulative income ($)',
    availableBalance: 'Available balance(yuan)',
    toBeSettled: 'pending settlement($)',
    monthEarnings: 'This month is earnings',
    todayEarnings: 'Today is earnings',
    reward: 'reward',
    other: 'other',
    reward1: 'Direct push rewards',
    reward2: 'inter-push rewards',
    reward3: 'Invitation reward',
    reward4: 'Platform changes',
    noProfitToday: 'There is no profit today~',
    totalPeople: 'Total number of invites',

    // promotion-order.vue
    unsettlement: 'unsettled',
    settled: 'settled',
    incomeExpired: 'Expired',
    // 订单失效原因
    reasonsForInvalidOrders1: 'Order fail, failure cause: Distribution commission is greater than or equal to the amount paid for the order',
    reasonsForInvalidOrders2: 'Order fail, failure cause: Order item successfully',
    reasonsForInvalidOrders3: 'Order fail, failure cause: Distribution commission is less than 0.01',

    // promotionProd.vue
    enterProductName: 'Please enter product name',
    newest: 'Newest',
    sales: 'sales',
    price: 'price',
    weChat: 'WeChat',
    QRCode: 'QR code',
    expectedEarn: 'expected to earn',
    saveAlbum: 'Save to album',
    shareIt: 'Share',
    downloadComplete: 'Saved to album',
    failedSave: 'Failed to save, please click Save to Album again',
    failedSaveTips: 'Failed to save, please authorize the relevant access rights',
    cpb: 'bWFsbDRq',
    shareFriendsNow: 'Share to friends now',
    shareFriendsTips1: 'You can get the corresponding commission after your friends successfully purchase through the page you share',
    shareFriendsTips2: 'Click on the top right corner of the screen to share this product with friends',

    // my-users.vue and my-friends.vue
    people: 'people',
    avatar: 'user avatar',
    nickname: 'user nickname',
    bindingDate: 'binding date',
    noUsersYet: 'No users yet~',
    notDistributionUsers: "You don't have distribution users yet~",
    notDistributionFriends: "You don't have distribution friends yet~",
    nicknameEmptyTips: 'User name cannot be empty',
    userInformation: 'User Information',
    cumulativeIncomeRMB: 'Cumulative Income (RMB)',
    joinTime: 'Join time：',
    totalInviteFriends: 'Number of friends invited',
    accumulatedOrders: 'Accumulated orders:',
    totalPromotionUsers: 'Number of Promoted users',
    distributionErrorTxt: 'Current function is not enabled',
    passAudit: 'Congratulations on your approval!'
  },

  // liveBroadcast.vue
  tabbarLive: 'Live',
  liveBroadcast: 'Live broadcast',
  inputBlogger: 'Input blogger / Studio / product',
  liveing: 'Liveing',
  notStarted: 'Not started',
  finished: 'Finished',
  noBroadcasting: 'No broadcasting',
  suspend: 'Suspend',
  abnormal: 'Abnormal',
  liveBroadcastTips: 'No relevant live data',
  pleaseOpenInWechat: 'Please open it in wechat applet',
  inLive: 'live',
  more: 'More',
  commodity: 'Goods',
  pickitUp: 'Pick it up',
  successfullyAddedCart: 'Successfully added to shopping cart',

  // user-login 用户登录
  userLogin: {
    userLogin: 'Login',
    username: 'Username',
    userName: 'Username',
    userNameCannotChange: 'Username cannot be changed',
    enterUsername: 'Moblie',
    usernameWarn: 'Please enter username',
    password: 'Password',
    enterPassword: 'Please enter password',
    changePassword: 'Change password',
    nextStep: 'Next',
    passwordVerification: 'Passwords are composed of three types of characters: letters, numbers, and special symbols. They are 8-20 half width characters and are case sensitive',
    enterNewPasswordTips: 'Please enter the correct password format',
    notUsername: 'No account yet?',
    registeredUsername: '\nGo to register',
    phoneNumber: 'Mobile',
    enterPhone: 'Enter phone number',
    phoneWarn: 'Malformed phone number',
    verificationCode: 'Verification code',
    enterCodeFirst: 'Please get the verification code first',
    getCode: 'Get verification code',
    enterCode: 'Verification code',
    newPassword: 'New password',
    enterNew: 'New password',
    confirmNew: 'Confirm password',
    enterNewAgain: 'Reenter new password',
    comparedPassword: 'Confirm password is inconsistent with new password',
    login: 'Login',
    loginSuccessful: 'Login successful!',
    backHomepage: 'Back to the homepage',
    confirmChanges: 'Confirm the changes',
    BackLogin: 'Back to login',
    backToPrev: 'Previous',
    pwdCantBeEmpty: 'Password cannot be empty',
    consentOfLoginRepresentative: 'Consent of Login Representative',
    consentOfRegisteredRepresentative: 'Consent of Registered Register',
    termsOfService: 'Terms of service',
    privacyPolicy: 'Privacy policy',
    and: 'and',
    forgetPwd: 'Forgot password',
    loginAgree: 'Have read and agree to',
    hadBind: 'The account associated with this cell phone number has been bound to other Wechat',
    regAgree: 'If the cell phone number is not registered will enter the registration process, registration is considered to agree',
    phoneFastLogin: 'WeChat login',
    otherLogMethods: 'Other login methods',
    phoneLogin: 'Mobile verification',
    accountLogin: 'Account Login',
    agreementTips: 'Please read and check the agreement first',
    bindedTipsTit: 'The account is bound to other WeChat',
    bindedTipsCon: 'One account can only be bound to one WeChat, your cell phone number is already bound to another WeChat, please unbind it first and then try again.',
    bindedTipsBtn: 'OK',
    codeErrorTips: 'Login information is abnormal, please login again',
    tips: 'Tips',
    confirm: 'confirm'
  },

  // cancellation 注销账号
  cancellation: {
    cancellationNotice: 'Cancellation Notice',
    cancellationCon: 'If you apply to cancel your Mall account, please confirm the following information before submitting your application to ensure the safety of your account and property: ',
    cancellationTips1: 'Your account is in normal use and has not been stolen, banned (ban, deactivation), other account abnormalities, etc.',
    cancellationTips2: 'The property in your account has been cleared. This includes: the balance in your wallet has been emptied or fully withdrawn, and there are no outstanding benefits or orders in your account. You may also choose to relinquish the property in the account.',
    cancellationTips3: 'The account has been unbundled or authorized to log in with a third-party product.',
    cancellationTips4: 'The account is not involved in any dispute disputes.',
    accountCancellation: 'Account cancellation',
    cancellationConfirmTips: 'Confirm account cancellation ?',
    cancellationConfirm: 'Confirm',
    cancellationCancel: 'Cancel',
    compulsoryCancellation: 'Compulsory cancellation'
  },

  // logout 退出登录
  logout: {
    logged: 'Logged',
    logoutNotice: 'Logging out will have the following effects.',
    logoutNotice1: 'Your account is unbundled from WeChat',
    logoutNotice2: 'Will not be able to use the assets of the account to place orders',
    logoutNotice3: 'Can not check the account order logistics information',
    logoutNotice4: 'Unable to receive coupons, red packets, etc.',
    logoutConfirm: 'Confirm logout?',
    logoutBtn: 'Logout',
    keepLogin: 'Cancel'
  }
}
